import { render } from "./ArchivedContainerTableView.vue?vue&type=template&id=3394f767&ts=true"
import script from "./ArchivedContainerTableView.vue?vue&type=script&lang=ts"
export * from "./ArchivedContainerTableView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__